import React, { useReducer, createContext } from 'react';
import reducers from './reducers';
import actionCreators from './actions';


const initialState = {
  //************SPECIALTIES************//
  specialties: [],
  selectedSpeciality: null,
  isSidebarRightOpen: false,

  //************SUBSPECIALTIES************//
  selectedSubSpeciality: null,

  //************CLINICAL CASES QUIZ************//
  clinicalCases: [],
  clinicalCasesFilters: [],
  activeFilters: null,
  selectedClinicalCase: null,
  loadingClinicalCase: false,
  isEditActive: false,
};

const reducer = (state = initialState, { type, payload }) => {
  return reducers[(payload.success && type) || 'ERROR'](state, payload);
};

export const context = createContext(initialState);

export default ({ children }) => {

  const [state, dispatch] = useReducer(reducer, initialState);

  const actions = actionCreators(state, dispatch);

  return <context.Provider
    value={{ state, actions }}>
    {children}
  </context.Provider>;
};
